
var lastScroll = 0;
var scrollGoal = 0;
exports.scrollTo = function(goal) {
	lastScroll = document.body.scrollTop;
	scrollGoal = Math.round(goal);
	console.log(scrollGoal);
	updateScroll();
}
function updateScroll() {
	console.log(lastScroll);
	console.log(document.body.scrollTop);
	if (document.body.scrollTop === lastScroll) {
		var newScroll = Math.round((document.body.scrollTop*0.8) + (scrollGoal*0.2));
		if (newScroll === lastScroll) newScroll += scrollGoal<newScroll ? -1 : 1;
		document.body.scrollTop = newScroll;
		if (newScroll === scrollGoal) return;
		lastScroll = newScroll;
		setTimeout(updateScroll, 40);
	}
}
